<!-- service has running build process and finished project core add -->
@if (!!state.buildProcess || !!state.deployProcess) {

  @if (!!state.buildProcess && (!!state.buildProcess?.appVersion?.build || !!state.buildProcess?.appVersion?.prepareCustomRuntime)) {
    <z-pipeline-detail
      [baseKey]="featureName"
      [logsScrollHeight]="state.isCompact
        ? 'calc(100vh - 220px)'
        : 'calc(100vh - 150px)'"
      [mode]="defaultMode"
      (modeChanged)="defaultMode = $event"
      [appVersion]="state.buildProcess?.appVersion">
    </z-pipeline-detail>
  }

  @if (!!state.deployProcess) {
    <h5 class="__deploy-title">
      Running deploy
    </h5>

    <div class="__deploy-item">
      <zui-process-item
        [translations]="state.processItemTranslations"
        [data]="state.deployProcess"
        (pipelineDetailClicked)="pipelineDetailClicked.emit($event)">
      </zui-process-item>
    </div>
  }

}

<!-- service doesn't have running build and project core add process -->
@if (!state.buildProcess && !state.deployProcess) {

  <div class="__intro">

    <h2 class="__intro_title">

      Ready to build, prepare,
      deploy <br/>and run your&nbsp;application

      on <br/>{{ state.serviceStack?.serviceStackTypeInfo.serviceStackTypeName }}

      service <strong>{{ state.serviceStack?.name }}</strong>

    </h2>

    <div class="__ng-content">
      <ng-content></ng-content>
    </div>

  </div>

  <zui-separator class="__intro-separator" [orientation]="'horizontal'" [size]="'large'" [spacing]="'large'" />

  <div class="__steps-grid">

    <!-- first step, add zerops.yml -->
    <div class="__step">

      <h3 class="__step_title">
        <zui-docs-text>
          Start by adding <a data-zui-new-docs="zerops-yaml/specification">zerops.yml</a> to the root of your repository&nbsp;and modify it to fit your application
        </zui-docs-text>
      </h3>

      <zui-separator
        class="__step_title-separator"
        [position]="'center'"
        [size]="'medium'"
        [spacing]="'medium'">
      </zui-separator>

      <div class="__editor-wrap">

        <button
          class="__editor-wrap_copy"
          (click)="copyZeropsYamlToClipboard()"
          type="button"
          mat-icon-button>
          <mat-icon class="__editor-wrap_copy-icon">content_copy</mat-icon>
        </button>

        <zui-code-field
          class="__editor"
          [ngClass]="'__editor--' + state.serviceStack?.serviceStackTypeId"
          [editorModel]="{
            language: 'yaml',
            fileName: 'zerops-yml'
          }"
          [editorOptions]="{
            quickSuggestions: {
              other: true,
              comments: false,
              strings: true
            },
            folding: true,
            glyphMargin: false,
            lineNumbers: 'off'
          }"
          [(ngModel)]="userProjectZeropsYaml"
        />

      </div>

      <!-- PHP nginx site conf -->
      @if (state.serviceStack?.serviceStackTypeId === serviceStackTypes.PhpNginx) {

        <zui-separator
          [orientation]="'vertical'"
          [size]="'medium'"
          [spacing]="'medium'" />

        <h4 class="__step_title  fx:mb-1-5">
          <zui-docs-text>
            Setup your <a data-zui-new-docs="php/how-to/customize-web-server#default-nginx-configuration">site_config.tmpl</a> file
          </zui-docs-text>
        </h4>

        <div class="__editor-wrap">

          <button
            class="__editor-wrap_copy"
            (click)="copySiteConfToClipboard()"
            type="button"
            mat-icon-button>
            <mat-icon class="__editor-wrap_copy-icon">content_copy</mat-icon>
          </button>

          <zui-code-field
            class="__editor __editor--site-conf"
            [editorModel]="{
              language: 'ini',
              fileName: 'site_config.tmpl'
            }"
            [editorOptions]="{
              quickSuggestions: {
                other: true,
                comments: false,
                strings: true
              },
              folding: true,
              glyphMargin: false,
              lineNumbers: 'off'
            }"
            [(ngModel)]="siteConfigPhpNginxCode"
          />

        </div>

      }

    </div>

    <!-- seconds step, trigger pipeline -->
    <div class="__step">

      <h3 class="__step_title">
        <zui-docs-text>
          Then trigger the build, prepare, deploy and&nbsp;run&nbsp;<a data-zui-new-docs="features/pipeline">pipeline</a>&nbsp;you set up in zerops.yml
        </zui-docs-text>
      </h3>

      <zui-separator
        class="__step_title-separator"
        [position]="'center'"
        [size]="'medium'"
        [spacing]="'medium'">
      </zui-separator>

      <!-- trigger automatically section -->
      <div class="__pipeline-item">

        <h4 class="__pipeline-item_title"><strong>Automatically</strong>, with each commit or release, by connecting the service with your GitHub or&nbsp;GitLab repository</h4>

        @if (!state.isReadOnly) {
          <z-remote-repository-connector [serviceStackId]="state.serviceStack?.id"></z-remote-repository-connector>
        }

      </div>

      @if (!state.isReadOnly) {
        <zui-separator
          class="__pipeline-item-separator"
          [position]="'center'"
          [spacing]="'none'"
          [size]="'large'"
          [orientation]="'horizontal'">
        </zui-separator>
      }

      <!-- trigger manually section -->
      <div class="__pipeline-item">

        <h4 class="__pipeline-item_title"><strong>Manually</strong>, by using Zerops CLI to trigger the pipeline from your existing CI/CD pipeline or from your local terminal</h4>

        <zui-zcli-examples
          [projectName]="state.serviceStack?.project.name | nameQuoting"
          [serviceId]="state.serviceStack?.id"
          [region]="region">
        </zui-zcli-examples>

      </div>

      <zui-separator
        class="__pipeline-item-separator"
        [position]="'center'"
        [spacing]="'none'"
        [size]="'large'"
        [orientation]="'horizontal'">
      </zui-separator>

      <!-- one-time trigger-->
      <div class="__pipeline-trigger-wrap">

        <h4 class="__pipeline-item_title"><strong>One-time</strong>, from a public GitHub / GitLab repository, or by defining a custom pipeline setup to trigger</h4>

        @if (!state.isReadOnly) {
          <button
            mat-flat-button
            color="accent"
            class="c-button--larger  c-button--full __deploy-button"
            (click)="onTriggerPipelineDialogOpen$.next()"
            type="button">
            <mat-icon fontSet="material-icons-outlined">cloud_sync</mat-icon>&nbsp;<span>Trigger new manual pipeline</span>
          </button>
        }

      </div>

    </div>

  </div>

}
